import { paletsHubsService } from "@/_services";
export const paletHub = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    entity: {
      data: [],
      status: {},
    },
    delete: {
      data: [],
      status: {},
    },
    update: {
      data: [],
      status: {},
    },
    post: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getPaletsHubsRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getPaletsHubsSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getPaletsHubsError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    deletePaletHubRequest(state) {
      state.delete.status = {
        deleting: true,
      };
    },
    deletePaletHubError(state, error) {
      state.delete.data = null;
      state.delete.status = {
        error,
      };
    },
    deletePaletHubSuccess(state, response) {
      state.delete.data = response;
      state.delete.status = {
        deleted: true,
      };
    },
    postPaletHubRequest(state) {
      state.post.status = {
        creating: true,
      };
    },
    postPaletHubError(state, error) {
      state.post.data = null;
      state.post.status = {
        error,
      };
    },
    postPaletHubSuccess(state, response) {
      state.post.data = response;
      state.post.status = {
        created: true,
      };
    },
    updatePaletHubRequest(state) {
      state.update.status = {
        updating: true,
      };
    },
    updatePaletHubError(state, error) {
      state.update.data = null;
      state.update.status = {
        error,
      };
    },
    updatePaletHubSuccess(state, response) {
      state.update.data = response;
      state.update.status = {
        updated: true,
      };
    },
    getPaletHubByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getPaletHubByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    getPaletHubByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getPaletsHubs({ commit }, request) {
      commit("getPaletsHubsRequest");
      paletsHubsService
        .getPaletsHubs(request.pagination, request.query)
        .then((response) => {
          commit("getPaletsHubsSuccess", response);
        })
        .catch((error) => {
          commit("getPaletsHubsError", error);
        });
    },
    deletePaletHub({ commit }, id) {
      commit("deletePaletHubRequest");
      paletsHubsService
        .deletePaletHub(id)
        .then((res) => {
          commit("deletePaletHubSuccess", res);
        })
        .catch((error) => {
          commit("deletePaletHubError", error);
        });
    },
    postPaletHub({ commit }, request) {
      commit("postPaletHubRequest");
      paletsHubsService
        .postPaletHub(request)
        .then((res) => {
          commit("postPaletHubSuccess", res);
        })
        .catch((error) => {
          commit("postPaletHubError", error);
        });
    },
    updatePaletHub({ commit }, request) {
      commit("updatePaletHubRequest");
      paletsHubsService
        .updatePaletHub(request.id, request.body)
        .then((res) => {
          commit("updatePaletHubSuccess", res);
        })
        .catch((error) => {
          commit("updatePaletHubError", error);
        });
    },
    getPaletHubById({ commit }, id) {
      commit("getPaletHubByIdRequest");
      paletsHubsService
        .getPaletHubById(id)
        .then((res) => {
          commit("getPaletHubByIdSuccess", res);
        })
        .catch((error) => {
          commit("getPaletHubByIdError", error);
        });
    },
  },
};
